import { render } from "./CaregiverFormPage.vue?vue&type=template&id=bbdc07c0&ts=true"
import script from "./CaregiverFormPage.vue?vue&type=script&lang=ts"
export * from "./CaregiverFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Patient/Caregivers/CaregiverFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bbdc07c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bbdc07c0', __exports__)) {
    api.reload('bbdc07c0', __exports__)
  }
  
  module.hot.accept("./CaregiverFormPage.vue?vue&type=template&id=bbdc07c0&ts=true", () => {
    api.rerender('bbdc07c0', render)
  })

}


export default __exports__